import axiosInstance from "../utils/axios";

export async function GetFirstAidBoxList(values, cancelToken) {
  return await axiosInstance().post(`/ohs/getBoxList`, values, {
    cancelToken: cancelToken
  });
}

export async function GetFirstAidBoxListFilters(cancelToken) {
  return await axiosInstance().get(`/ohs/getBoxListFilters`, {
    cancelToken: cancelToken
  });
}

export async function GetFirstAidBox(id, cancelToken) {
  return await axiosInstance().get(`/ohs/getBox`, {
    params: { id: id },
    cancelToken: cancelToken
  });
}

export async function CreateFirstAidBox(values) {
  return await axiosInstance().post(`/ohs/createBox`, values);
}

export async function UpdateFirstAidBox(values) {
  return await axiosInstance().post(`/ohs/updateBox`, values);
}

export async function UpdateFirstAidBoxAssignment(values) {
  return await axiosInstance().post(`/ohs/updateBoxAssignment`, values);
}

export async function DeleteFirstAidBox(id) {
  return await axiosInstance().post(`/ohs/deleteBox`, { id: id });
}

export async function GetFirstAiderCandidates(cancelToken) {
  return await axiosInstance().get(`/ohs/getFirstAiderCandidates`, {
    cancelToken: cancelToken
  });
}

export async function GetFirstAidCatalog(cancelToken) {
  return await axiosInstance().get(`/ohs/getCatalog`, {
    cancelToken: cancelToken
  });
}

export async function SaveFirstAidCatalogItem(values) {
  return await axiosInstance().post(`/ohs/saveCatalogItem`, values);
}

export async function DeleteFirstAidCatalogItem(id) {
  return await axiosInstance().post(`/ohs/deleteCatalogItem`, { id: id });
}

export async function StartFirstAidCheck(values) {
  return await axiosInstance().post(`/ohs/startCheck`, values);
}

export async function FinishFirstAidCheck(openingId) {
  return await axiosInstance().post(`/ohs/finishCheck`, { openingId: openingId });
}

export async function SubmitFirstAidCheck(values) {
  return await axiosInstance().post(`/ohs/submitCheck`, values);
}

export async function GetFirstAidManagerOverview(cancelToken) {
  return await axiosInstance().get(`/ohs/getManagerOverview`, {
    cancelToken: cancelToken
  });
}

export async function GetFirstAidRestockList(cancelToken) {
  return await axiosInstance().get(`/ohs/getRestockList`, {
    cancelToken: cancelToken
  });
}

export async function GetFirstAidDiscrepancies(cancelToken) {
  return await axiosInstance().get(`/ohs/getDiscrepancies`, {
    cancelToken: cancelToken
  });
}

export async function GetFirstAidAnalytics(expiryWindowDays, cancelToken) {
  return await axiosInstance().get(`/ohs/getAnalytics`, {
    params: { expiryWindowDays: expiryWindowDays },
    cancelToken: cancelToken
  });
}

export async function GetFirstAidBoxUsageForm(boxCode, cancelToken) {
  return await axiosInstance().get(`/ohs/usage/getBox`, {
    params: { code: boxCode },
    cancelToken: cancelToken
  });
}

export async function SubmitFirstAidBoxUsage(values) {
  return await axiosInstance().post(`/ohs/usage/submit`, values);
}

export async function AcknowledgeFirstAidTagMismatch(id, note) {
  return await axiosInstance().post(`/ohs/acknowledgeTagMismatch`, { id: id, note: note });
}

export async function GetFirstAidBoxQrCode(id, origin) {
  return await axiosInstance().get(`/ohs/getBoxQrCode`, {
    params: { id: id, origin: origin }
  });
}

export async function GetFirstAidReportFilters(cancelToken) {
  return await axiosInstance().get(`/ohs/getReportFilters`, {
    cancelToken: cancelToken
  });
}

export async function GetFirstAidUsageReport(values, cancelToken) {
  return await axiosInstance().post(`/ohs/getUsageReport`, values, {
    cancelToken: cancelToken
  });
}

export async function GetFirstAidCheckHistory(values, cancelToken) {
  return await axiosInstance().post(`/ohs/getCheckHistory`, values, {
    cancelToken: cancelToken
  });
}

export async function GetOhsBuildingCheckList(cancelToken) {
  return await axiosInstance().get(`/ohs/getBuildingCheckList`, {
    cancelToken: cancelToken
  });
}

export async function GetOhsBuildingCheckFilters(cancelToken) {
  return await axiosInstance().get(`/ohs/getBuildingCheckFilters`, {
    cancelToken: cancelToken
  });
}

export async function UpdateOhsBuildingRepresentatives(buildingId, ohsRepresentativeIds) {
  return await axiosInstance().post(`/ohs/updateBuildingRepresentatives`, {
    buildingId: buildingId,
    ohsRepresentativeIds: ohsRepresentativeIds
  });
}

export async function GetOhsBuildingCheckForm(buildingId, cancelToken) {
  return await axiosInstance().get(`/ohs/getBuildingCheckForm`, {
    params: { buildingId: buildingId },
    cancelToken: cancelToken
  });
}

export async function SubmitOhsBuildingCheck(values) {
  return await axiosInstance().post(`/ohs/submitBuildingCheck`, values);
}

export async function GetOhsBuildingCheckHistory(values, cancelToken) {
  return await axiosInstance().post(`/ohs/getBuildingCheckHistory`, values, {
    cancelToken: cancelToken
  });
}

export async function GetOhsBuildingCheckQuestions(cancelToken) {
  return await axiosInstance().get(`/ohs/getBuildingCheckQuestions`, {
    cancelToken: cancelToken
  });
}

export async function SaveOhsBuildingCheckQuestion(values) {
  return await axiosInstance().post(`/ohs/saveBuildingCheckQuestion`, values);
}

export async function DeleteOhsBuildingCheckQuestion(id) {
  return await axiosInstance().post(`/ohs/deleteBuildingCheckQuestion`, { id: id });
}

export async function AuditTrailOhs(values, cancelToken) {
  return await axiosInstance().post(`/ohs/auditTrail`, values, {
    cancelToken: cancelToken
  });
}

export async function AuditTrailFilterOhs(values, cancelToken) {
  return await axiosInstance().get(`/ohs/auditTrailFilters`, {
    params: values,
    cancelToken: cancelToken
  });
}

export async function GetMyOhsAccess(cancelToken) {
  return await axiosInstance().get(`/ohs/getMyAccess`, {
    cancelToken: cancelToken
  });
}

export async function GetOhsPeople(role, cancelToken) {
  return await axiosInstance().get(`/ohs/getPeople`, {
    params: { role: role },
    cancelToken: cancelToken
  });
}

export async function GetOhsPeopleCandidates(role, cancelToken) {
  return await axiosInstance().get(`/ohs/getPeopleCandidates`, {
    params: { role: role },
    cancelToken: cancelToken
  });
}

export async function AddOhsPerson(role, userId) {
  return await axiosInstance().post(`/ohs/addPerson`, { role: role, userId: userId });
}

export async function RemoveOhsPerson(role, userId) {
  return await axiosInstance().post(`/ohs/removePerson`, { role: role, userId: userId });
}
